import api from './client'

// FINANZAS → Pago a proveedores (Martin, 26 oct 2026): pagos hechos en Presea
// (DETALLE_PAGO), legajo y envío al proveedor.
const base = '/pagos-proveedor'

export const pagosProveedorApi = {
  listar: (params) => api.get(base, { params }),
  sincronizar: () => api.post(`${base}/sincronizar`),
  ver: (id) => api.get(`${base}/${id}`),
  legajoHtml: (id) => api.get(`${base}/${id}/legajo`, { responseType: 'text' }),
  // Multipart: el pagador puede sumar archivos (comprobantes del banco, etc.).
  enviar: (id, datos, archivos = []) => {
    const fd = new FormData()
    Object.entries(datos).forEach(([k, v]) => { if (v !== null && v !== undefined && v !== '') fd.append(k, v) })
    archivos.forEach(f => fd.append('adjuntos[]', f))
    return api.post(`${base}/${id}/enviar`, fd)
  },
  enviarLote: (ids) => api.post(`${base}/enviar-lote`, { ids, canal: 'email_lgr' }),
  async descargarPdf(id, nombre) {
    const { data } = await api.get(`${base}/${id}/pdf`, { responseType: 'blob' })
    const href = URL.createObjectURL(data)
    const a = document.createElement('a')
    a.href = href
    a.download = nombre
    document.body.appendChild(a)
    a.click()
    a.remove()
    setTimeout(() => URL.revokeObjectURL(href), 1000)
  },
}

export const CANALES_LEGAJO = [
  { value: 'email_lgr', label: 'Mail de LGR', ayuda: 'Sale de LGR - Administracion con el legajo y tus adjuntos; las respuestas te llegan a vos.' },
  { value: 'email_local', label: 'Mi programa de correo', ayuda: 'Se baja el legajo y se abre el correo de tu computadora (Outlook, Mail…) con el mensaje armado: adjuntás el PDF y lo mandás vos.' },
  { value: 'whatsapp', label: 'Mi WhatsApp', ayuda: 'Abre tu WhatsApp con el mensaje y los links al legajo y a tus adjuntos (vencen a los 30 días).' },
]
